// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Options/EnumValueOptions.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumValueOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { UuidDto } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";

/**
 * Describes the file Options/EnumValueOptions.proto.
 */
export const file_Options_EnumValueOptions: GenFile = /*@__PURE__*/
  fileDesc("Ch5PcHRpb25zL0VudW1WYWx1ZU9wdGlvbnMucHJvdG86XAoCaWQSIS5nb29nbGUucHJvdG9idWYuRW51bVZhbHVlT3B0aW9ucxj42PkBIAEoCzImLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29tbW9uLlV1aWREdG9SAmlkOkcKDGZpZWxkX251bWJlchIhLmdvb2dsZS5wcm90b2J1Zi5FbnVtVmFsdWVPcHRpb25zGPnY+QEgAygFUgtmaWVsZE51bWJlcjpHCgxkaXNwbGF5X25hbWUSIS5nb29nbGUucHJvdG9idWYuRW51bVZhbHVlT3B0aW9ucxj62PkBIAEoCVILZGlzcGxheU5hbWVCJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5NZXNzYWdlc2IGcHJvdG8z", [file_google_protobuf_descriptor, file_Messages_Common]);

/**
 * Allows placement of GUIDs on enumeration values.
 *
 * @generated from extension: time_tracking.messages.common.UuidDto id = 4091000;
 */
export const id: GenExtension<EnumValueOptions, UuidDto> = /*@__PURE__*/
  extDesc(file_Options_EnumValueOptions, 0);

/**
 * Allows placement of ordering field numbers on enumeration values.
 *
 * @generated from extension: repeated int32 field_number = 4091001;
 */
export const field_number: GenExtension<EnumValueOptions, number[]> = /*@__PURE__*/
  extDesc(file_Options_EnumValueOptions, 1);

/**
 * Allows placement of a descriptive name on enumeration values.
 *
 * @generated from extension: string display_name = 4091002;
 */
export const display_name: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_Options_EnumValueOptions, 2);

